import { TASK_LABELS } from "~/lib/catalog-model"
import { ACTIVITY_LABELS } from "~/lib/repository-activity"

export const TOOL_TYPE_LABELS: Record<string, string> = {
  Product: "Platforms & services",
  Project: "Libraries & tools",
  Infrastructure: "Infrastructure",
  Unknown: "Other tools",
}

export const TOOL_CARD_TYPE_LABELS: Record<string, string> = {
  Product: "Platform or service",
  Project: "Library or tool",
  Infrastructure: "Infrastructure",
  Unknown: "Tool",
}

export const DELIVERY_MODEL_LABELS: Record<string, string> = {
  SaaS: "SaaS",
  API: "API",
  Framework: "Framework",
  Library: "Library",
  SDK: "SDK",
  CLI: "CLI",
  BrowserExtension: "Browser extension",
  Desktop: "Desktop app",
  SelfHosted: "Self-hosted",
}

const CAPABILITY_LABELS: Record<string, string> = {
  "no-code": "No-code",
  "self-hosted": "Self-hosted",
  "javascript-rendering": "JavaScript rendering",
  "markdown-output": "Markdown output",
  "sitemap-parsing": "Sitemap parsing",
  "change-monitoring": "Change monitoring",
  scheduling: "Scheduling",
  exports: "Data exports",
}

export function catalogFilterOptionLabel(type: string, value: string): string {
  const labels =
    type === "entityType"
      ? TOOL_TYPE_LABELS
      : type === "deliveryModel"
        ? DELIVERY_MODEL_LABELS
        : type === "capability"
          ? CAPABILITY_LABELS
          : type === "maintenance"
            ? ACTIVITY_LABELS
            : type === "accessModel"
              ? {
                  "open-source": "Open-source code",
                  "free-plan": "Free plan",
                  "free-trial": "Free trial",
                  sandbox: "Sandbox",
                  "free-credits": "Free credits",
                  "free-self-hosted": "Free to self-host",
                  "free-noncommercial": "Free for noncommercial use",
                  paid: "Paid",
                  unknown: "Not verified",
                }
              : type === "language"
                ? {}
                : TASK_LABELS
  return labels[value] ?? value.replaceAll("-", " ")
}
